export interface IRedVisionSearchResponse {
  createdAt: string;
  externalId: string;
  id: string;
  taskId: string;
  updated_At: string;
  priority: 'Normal' | 'High';
  instructions?: string;
}

export type IRedVisionSearchData = IRedVisionSearchResponse;

export const convertFromRedVisionSearchResponseToRedVisionSearchData = (
  data: IRedVisionSearchResponse
): IRedVisionSearchData => data;
export const convertFromRedVisionSearchDataToRedVisionSearchResponse = (
  data: IRedVisionSearchData
): IRedVisionSearchResponse => data;
